var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 132,
    viewBox: "0 0 109 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2169 123.217C84.16 123.217 108.434 98.9432 108.434 69.0001C108.434 39.0569 84.16 14.7832 54.2169 14.7832C24.2737 14.7832 0 39.0569 0 69.0001C0 98.9432 24.2737 123.217 54.2169 123.217Z",
    fill: "url(#paint0_linear_4834_3084)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4834_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2988 45.8672H23.1301C21.1339 45.8672 19.5156 47.4854 19.5156 49.4816V125.385C19.5156 127.381 21.1339 129 23.1301 129H85.2988C87.295 129 88.9132 127.381 88.9132 125.385V49.4816C88.9132 47.4854 87.295 45.8672 85.2988 45.8672Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9873 56.7109H28.1921C26.9944 56.7109 26.0234 57.6819 26.0234 58.8796C26.0234 60.0773 26.9944 61.0483 28.1921 61.0483H46.9873C48.185 61.0483 49.156 60.0773 49.156 58.8796C49.156 57.6819 48.185 56.7109 46.9873 56.7109Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9993 66.1094H28.1921C26.9944 66.1094 26.0234 67.0803 26.0234 68.278C26.0234 69.4758 26.9944 70.4467 28.1921 70.4467H59.9993C61.1971 70.4467 62.168 69.4758 62.168 68.278C62.168 67.0803 61.1971 66.1094 59.9993 66.1094Z",
    fill: "#DFEAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9873 76.2285H28.1921C26.9944 76.2285 26.0234 77.1995 26.0234 78.3972C26.0234 79.5949 26.9944 80.5659 28.1921 80.5659H46.9873C48.185 80.5659 49.156 79.5949 49.156 78.3972C49.156 77.1995 48.185 76.2285 46.9873 76.2285Z",
    fill: "#B4DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9993 85.627H28.1921C26.9944 85.627 26.0234 86.5979 26.0234 87.7956C26.0234 88.9934 26.9944 89.9643 28.1921 89.9643H59.9993C61.1971 89.9643 62.168 88.9934 62.168 87.7956C62.168 86.5979 61.1971 85.627 59.9993 85.627Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9873 95.748H28.1921C26.9944 95.748 26.0234 96.719 26.0234 97.9167C26.0234 99.1144 26.9944 100.085 28.1921 100.085H46.9873C48.185 100.085 49.156 99.1144 49.156 97.9167C49.156 96.719 48.185 95.748 46.9873 95.748Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9993 105.146H28.1921C26.9944 105.146 26.0234 106.117 26.0234 107.315C26.0234 108.513 26.9944 109.484 28.1921 109.484H59.9993C61.1971 109.484 62.168 108.513 62.168 107.315C62.168 106.117 61.1971 105.146 59.9993 105.146Z",
    fill: "#DFEAFB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4834_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2988 9H23.1301C21.1339 9 19.5156 10.6182 19.5156 12.6145V34.3012C19.5156 36.2974 21.1339 37.9157 23.1301 37.9157H85.2988C87.295 37.9157 88.9132 36.2974 88.9132 34.3012V12.6145C88.9132 10.6182 87.295 9 85.2988 9Z",
    fill: "#1485FD"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9873 16.9531H28.1921C26.9944 16.9531 26.0234 17.9241 26.0234 19.1218C26.0234 20.3195 26.9944 21.2905 28.1921 21.2905H46.9873C48.185 21.2905 49.156 20.3195 49.156 19.1218C49.156 17.9241 48.185 16.9531 46.9873 16.9531Z",
    fill: "#B4DAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9993 26.3516H28.1921C26.9944 26.3516 26.0234 27.3225 26.0234 28.5202C26.0234 29.718 26.9944 30.6889 28.1921 30.6889H59.9993C61.1971 30.6889 62.168 29.718 62.168 28.5202C62.168 27.3225 61.1971 26.3516 59.9993 26.3516Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4834_3084",
    x: 13.5156,
    y: 36.8672,
    width: 81.3984,
    height: 95.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4834_3084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4834_3084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4834_3084",
    x: 13.5156,
    y: 0,
    width: 81.3984,
    height: 40.916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4834_3084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4834_3084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4834_3084",
    x1: 54.2169,
    y1: 14.7832,
    x2: 54.2169,
    y2: 123.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoice);
export default __webpack_public_path__ + "static/media/no-invoice.1036b2f700b3ef5be45b8c07ddf1a099.svg";
export { ForwardRef as ReactComponent };